import { useParams } from "react-router-dom";
import pageData from "../content/pages.json";
import Hero from "../components/landlord/Hero";
import WhyFms from "../components/landlord/WhyFms";
import AllOnePlace from "../components/landlord/AllOnePlace";
import Subscribe from "../UI/subscribe";

const Product = () => {
  const { slug } = useParams();
  const page = pageData.find((item) => item.slug === slug);

  if (!page) {
    return <div className="p-6 text-red-600">Page not found</div>;
  }

  return (
    <div className="">
      <Hero data={page.hero} />
      <AllOnePlace data={page.NeedPlace} />
      <WhyFms data={page.section2} />
      <Subscribe data={page.subscribe} />
    </div>
  );
};

export default Product;
